import React from "react";
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";

import FormClient from '../form-client/index';
import FormStore from '../form-store';
import FormItems from '../form-items';
import FormCashier from '../form-cashier';


const isAuthenticated = () => {
  /*const token = localStorage.getItem('token');
  return !!token && !isTokenExpired(token);*/
  return true;
}

const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={props =>
      isAuthenticated() ? (
        <Component {...props} />
      ) : (
        <Redirect to={{ pathname: "/login", state: { from: props.location } }} />
      )
    }
  />
);

const Routes = () => (
  <BrowserRouter>
    <Switch>
      <PrivateRoute path="/criar-cashier" component={FormCashier} />
      <PrivateRoute path="/criar-item" component={FormItems} />
      <PrivateRoute path="/criar-store" component={FormStore} />
      <PrivateRoute path="/" component={FormClient} />
    </Switch>
  </BrowserRouter>
);

export default Routes;



// WEBPACK FOOTER //
// ./src/components/client/Routes.js